import { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";

const ThemeContext = createContext(null);

export function ThemeProvider({ children, isAuthed }) {
  const [theme, setThemeState] = useState(() => {
    return localStorage.getItem("flowtasks_theme") || "dark";
  });

  useEffect(() => {
    const root = document.documentElement;
    if (theme === "dark") root.classList.add("dark");
    else root.classList.remove("dark");
    localStorage.setItem("flowtasks_theme", theme);
  }, [theme]);

  // When auth changes, fetch settings.theme from server (source of truth)
  useEffect(() => {
    if (!isAuthed) return;
    api
      .get("/settings")
      .then(({ data }) => {
        if (data?.theme && data.theme !== theme) {
          setThemeState(data.theme);
        }
      })
      .catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthed]);

  const setTheme = async (next) => {
    setThemeState(next);
    if (isAuthed) {
      try {
        await api.put("/settings", { theme: next });
      } catch {}
    }
  };

  const toggle = () => setTheme(theme === "dark" ? "light" : "dark");

  return (
    <ThemeContext.Provider value={{ theme, setTheme, toggle }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);
